import React, {PureComponent} from "react";
import Table from "react-bootstrap/Table";
import {PropTypes} from "prop-types";
import './index.css';
import {debug, removeAt} from "../../../utility/functions";
import {appendStrings} from "../GenericTable/functions";

class BetterGenericTable extends PureComponent {

	constructor(props) {
		super(props);
		this.state = {
			selectedRows: this.props.selectedRows,
		}
	}


	render() {
		return (
			<div>
				<Table striped responsive="sm" style={{overflow: 'auto'}}>
					<thead className='generic-table-header'>
						{this.renderHeader()}
					</thead>
					<tbody>
						{this.renderRows()}
					</tbody>
				</Table>
			</div>
		);
	}


	renderHeader = () => {
		const {headerComponent} = this.props;

		if (headerComponent) return headerComponent;

		return (
			<tr
				key={'header-row'}
			>
				{this.renderHeaderColumns()}
			</tr>
		)
	};

	renderHeaderColumns = () => {
		const {columns} = this.props;

		if (!columns || columns.length === 0) return null;

		return columns.map((item, index) => {

			if (item.headerComponent) return item.headerComponent;

			return (
				<th
					key={'header-column-' + index}
					className={item.headerClassName}
				>
					{item.name}
				</th>
			)
		})
	};

	renderRows = () => {
		const {loading, data} = this.props;

		if(loading) return this.renderLoadingComponent();

		if (!data || data.length === 0) return this.renderEmptyTableComponent();

		return data.map((row, index) => this.renderRowContent(row, index));
	};

	renderRowContent = (row, index) => {
		const {rowLoading, rowLoadingComponent, onRenderRow, columns} = this.props;

		if(rowLoading) {
			const isRowLoading = rowLoading(row, index);
			if(isRowLoading) {
				if(rowLoadingComponent) {
					return(
						<tr
							key={'table-loading-component'}
							className='better-generic-table-loading-component-tr'
						>
							<td
								key={'no-data-row'}
								colSpan={columns.length}
								className='better-generic-table-loading-component-td'
							>
								<div className='better-generic-table-loading-component-div'>
									{rowLoadingComponent}
								</div>
							</td>
						</tr>
					)
				}
				return this.renderLoadingComponent();
			}
		}

		if(onRenderRow) {
			const Component = onRenderRow(row, index, columns);
			if(Component) return Component
		}

		return(
			<tr
				key={'data-row-' + index}
				className={this.getRowCssClasses(index)}
				onClick={() => {this.onRowClicked(row, index)}}
			>
				{this.renderRowColumns(row, index)}
			</tr>
		);
	};

	renderRowColumns = (row, index) => {
		const {columns} = this.props;

		if(!columns || columns.length === 0) return null;

		return columns.map((field, i) => {

			if(field.rowComponent) {
				const Component = field.rowComponent(row, index);
				if(Component) {
					return (
						<td
							key={'data-row-' + index + '-column-' + i}
							className={this.getRowColumnCssClasses(field)}
						>
							{Component}
						</td>
					)
				}
			}

			return(
				<td
					key={'data-row-' + index + '-column-' + i}
					className={this.getRowColumnCssClasses(field)}
				>
					{field.value? field.value(row, index) : "null"}
				</td>
			)
		})
	};

	renderLoadingComponent = () => {
		const {loadingComponent, columns} = this.props;

		if(!columns || columns.length === 0) return null;

		return(
			<tr
				key={'table-loading-component'}
				className='better-generic-table-loading-component-tr'
			>
				<td
					key={'no-data-row'}
					colSpan={columns.length}
					className='better-generic-table-loading-component-td'
				>
					<div className='better-generic-table-loading-component-div'>
						{loadingComponent}
					</div>
				</td>
			</tr>
		)
	};

	renderEmptyTableComponent = () => {
		const {emptyTableComponent, columns} = this.props;

		if(!columns || columns.length === 0) return null;

		return(
			<tr
				key={'table-empty-message-component'}
				className='better-generic-table-empty-table-component-tr'
			>
				<td
					key={'no-data-row'}
					colSpan={columns.length}
					className='better-generic-table-empty-table-component-td'
				>
					<div className='better-generic-table-empty-table-component-div'>
						{emptyTableComponent}
					</div>
				</td>
			</tr>
		)
	};

	onRowClicked = (row, index) => {
		const {onRowClicked} = this.props;

		if(onRowClicked) onRowClicked(row, index);

		this.handleRowSelection(row, index)
	};

	handleRowSelection = (row, index) => {
		const {selectionMode} = this.props;

		if(selectionMode === 'none') return null;

		if(this.isRowSelected(index)) {
			this.deselectRow(row, index);
		} else {
			this.selectRow(row, index);
		}
	};

	isRowSelected = (index) => {
		const {selectedRows} = this.state;
		if(!selectedRows || selectedRows.length === 0) return false;
		return selectedRows.some(value => value === index);
	};

	selectRow = (row, index) => {
		const {selectionMode, selectionCap, onRowSelected, onSelectedRowsChanged} = this.props;
		const {selectedRows} = this.state;

		if(onRowSelected) onRowSelected(row, index);

		switch (selectionMode) {
			case 'single':
				this.setState({
					selectedRows: [index]
				}, () => {
					if(onSelectedRowsChanged) onSelectedRowsChanged(selectedRows);
				});
				break;
			case 'multi':
				if(!selectedRows) {
					this.setState({
						selectedRows: [index]
					}, () => {
						if(onSelectedRowsChanged) onSelectedRowsChanged(selectedRows);
					});
				} else {
					this.setState({
						selectedRows: [...selectedRows, index]
					},() => {
						if(onSelectedRowsChanged) onSelectedRowsChanged(selectedRows);
					});
				}
				break;
			case 'capped':
				if(!selectedRows) {
					this.setState({selectedRows: [index]});
				} else {
					if(selectedRows.length === selectionCap) {
						this.setState({
							selectedRows: [...selectedRows.filter((value, i) => i !== 0), index]
						}, () => {
							if(onSelectedRowsChanged) onSelectedRowsChanged(selectedRows);
						});
					} else {
						this.setState({
							selectedRows: [...selectedRows, index]
						}, () => {
							if(onSelectedRowsChanged) onSelectedRowsChanged(selectedRows);
						});
					}
				}
				break;
		}
	};

	deselectRow = (row, index) => {
		const {onRowDeselected, onSelectedRowsChanged} = this.props;
		const {selectedRows} = this.state;

		if(onRowDeselected) onRowDeselected(row, index);

		if(selectedRows.length === 1) {
			this.setState({
				selectedRows: null
			}, () => {
				if(onSelectedRowsChanged) onSelectedRowsChanged(selectedRows);
			});
		} else {
			this.setState({
				selectedRows: [...selectedRows.filter((value, i) => value !== index)]
			}, () => {
				if(onSelectedRowsChanged) onSelectedRowsChanged(selectedRows);
			});
		}
	};

	getRowColumnCssClasses = (field) => {
		const {rowColumnsClassName} = this.props;

		let className;

		if(field.rowClassName) className = field.rowClassName;
		if(rowColumnsClassName) className = appendStrings(className, rowColumnsClassName);
		return className;
	};

	getRowCssClasses = (index) => {
		const {rowContainerClassName} = this.props;
		const {selectedRows} = this.state;
		let className = 'better-generic-table-row-tr';

		if(rowContainerClassName) className = appendStrings(className, rowContainerClassName);
		if(selectedRows && selectedRows.some(value => value === index)) {
			className = appendStrings(className, 'better-generic-table-row-tr-selected');
		}
		return className;
	}
}

BetterGenericTable.defaultProps = {
	data: null,
	columns: null,
	selectionMode: 'none',
	selectedRows: null,
	selectionCap: null,
	onRowClicked: null,
	onRowSelected: null,
	onRowDeselected: null,
	onSelectedRowsChanged: null,
	onRenderRow: null,
	rowLoading: null,
	rowLoadingComponent: null,
	rowContainerClassName: null,
	rowColumnsClassName: null,
	loading: false,
	loadingComponent: <p className='better-generic-table-empty-table-message'>Loading...</p>,
	headerComponent: null,
	emptyTableComponent: null,
};

BetterGenericTable.propTypes = {
	data: PropTypes.arrayOf(PropTypes.any),
	columns: PropTypes.arrayOf(
		PropTypes.exact({
			name: PropTypes.string,
			value: PropTypes.func,
			headerClassName: PropTypes.string,
			rowClassName: PropTypes.string,
			headerComponent: PropTypes.func,
			rowComponent: PropTypes.func,
		})
	),
	selectionMode: PropTypes.oneOf([
		'none',
		'single',
		'multi',
		'capped',
	]),
	selectedRows: PropTypes.arrayOf(PropTypes.number),
	selectionCap: PropTypes.number,
	onRowClicked: PropTypes.func,
	onRowSelected: PropTypes.func,
	onRowDeselected: PropTypes.func,
	onSelectedRowsChanged: PropTypes.func,
	onRenderRow: PropTypes.func,
	rowLoading: PropTypes.func,
	rowLoadingComponent: PropTypes.node,
	rowContainerClassName: PropTypes.string,
	rowColumnsClassName: PropTypes.string,
	loading: PropTypes.bool,
	loadingComponent: PropTypes.node,
	headerComponent: PropTypes.node,
	emptyTableComponent: PropTypes.node,
};

export default BetterGenericTable;
